import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { DepartmentFragmentDoc } from '../../fragments/generated/Department';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DepartmentQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type DepartmentQuery = { department?: { id: string, name: string } | null };


export const DepartmentDocument = /*#__PURE__*/ gql`
    query department($id: String!) {
  department(filters: {id: $id}) {
    ...Department
  }
}
    ${DepartmentFragmentDoc}`;

export function useDepartmentQuery(options: Omit<Urql.UseQueryArgs<DepartmentQueryVariables>, 'query'>) {
  return Urql.useQuery<DepartmentQuery, DepartmentQueryVariables>({ query: DepartmentDocument, ...options });
};